import { Component, Input } from '@angular/core';
import { StatsCount } from '../../models/operations_persona';

@Component({
  selector: 'app-stats-data',
  templateUrl: './stats-data.component.html',
  styleUrls: ['./stats-data.component.scss'],
  standalone: false,
})
export class StatsDataComponent {
  @Input() title = '';
  @Input() data: StatsCount = <StatsCount>{};
  // @Input() data:StatsData[]=[];
  constructor() {}
}
